
import { Options, Vue } from "vue-class-component";
import { PropType } from "vue";
import AppInput from "@/components/common/form/AppInput.vue";
import AppButton from "@/components/common/AppButton.vue";

@Options({
  components: { AppButton, AppInput },
  emits: ["onEditTurretUrl", "onDeleteTurretUrl"],
  props: {
    turretsUrls: {
      type: Array as PropType<string[]>,
    },
  },
})
export default class TurretUrlList extends Vue {
  editTurretUrl(url: string): void {
    this.$emit("onEditTurretUrl", url);
  }

  deleteTurretUrl(url: string): void {
    this.$emit("onDeleteTurretUrl", url);
  }
}
